import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Routers from "./router";
import Loader from "./component/Loader";
import Layout from "./component/Layout/layout";
import Logo from "./assets/images/resQLogo.svg";
import { getCookie, deleteAllCookies, forceLogout } from "./helpers/general";
import { getUserDetails } from "./api/user";
import AlertMessage from "./component/common/AlertMessage";
import {
  setRequestStatus,
  showLoader,
  stopLoader,
} from "./redux/slices/generalSlice";
import { useGApageview } from "./helpers/hooks";
import { getBrandList } from "./api/orders";
import "./App.css";
import "./common.css";

const App = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [userAuth, setUserAuth] = React.useState(false);
  const [firstTime, setFirstTime] = React.useState(false);
  const {
    general: { requestStatus },
  } = useSelector((state) => state);

  useEffect(() => {
    const fetchData = async () => {
      console.log("fetch data");
      const routeTo = "login";
      const auth = getCookie("userAuth");
      setUserAuth(Boolean(auth));
      if (auth) {
        setFirstTime(true);
        console.log("fetch data inside");
        try {
          dispatch(showLoader());
          const [userDetailsResponse, otherApiResponse] = await Promise.all([
            dispatch(getUserDetails()),
            dispatch(getBrandList()),
          ]);
          if (userDetailsResponse && otherApiResponse) {
            dispatch(stopLoader());
          } else {
            deleteAllCookies();
            forceLogout();
            window.location = `${window.location.origin}/${routeTo}`;
          }
        } catch (error) {
          console.error("API calls failed", error);
          deleteAllCookies();
          forceLogout();
          window.location = `${window.location.origin}/${routeTo}`;
        }
      }
    };
    if (!firstTime) {
      fetchData();
    }
    console.log("fetch data outside");
  }, [location, dispatch]);

  useGApageview();

  return (
    <div className="App">
      <Loader />
      <Layout logo={Logo} profilePicture="" isPublicRoute={userAuth}>
        <Routers />
        {requestStatus.show &&
          (requestStatus.header || requestStatus.description) && (
            <AlertMessage
              header={requestStatus.header}
              description={requestStatus.description}
              variantType={requestStatus.error ? "default" : "success"}
              setShowSnackbar={() =>
                dispatch(setRequestStatus({ show: false }))
              }
            />
          )}
      </Layout>
    </div>
  );
};

export default App;
